import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject,switchMap } from 'rxjs';
import { SwapWifiService } from 'src/app/services/swap-wifi.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmDialogService } from '../swap-wifi-shared-module/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-introduce-wifi6',
  templateUrl: './introduce-wifi6.component.html',
  styleUrls: ['./introduce-wifi6.component.scss'],
})
export class IntroduceWifi6Component implements OnInit {
  constructor(
    readonly route: ActivatedRoute,
    readonly router: Router,
    readonly swapWifiService: SwapWifiService,
    readonly spinner: NgxSpinnerService,
    readonly confirm: ConfirmDialogService
  ) {
    this.route.queryParams.subscribe((params: any) => {
      this.utmSource = params['utm_source'];
      const section = params['section'];
      if (section) {
        this.scrollToSection(section);
      }
    });
  }
  showItem1: boolean = false;
  showItem2: boolean = false;
  showItem3: boolean = false;
  showItem4: boolean = false;
  showItem5: boolean = false;
  advantageList = [
    {
      icon: 'https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/tuongthich.png',
      title: 'Tương thích tốt hơn',
      content:
        'Wi-Fi 6 hoạt động trên cả 2 loại tần số sóng 2.4Ghz và 5Ghz, tương thích với các thiết bị hỗ trợ tần số sóng khác nhau & tương thích ngược với các tiêu chuẩn Wi-Fi trước.',
    },
    {
      icon: 'https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/tocdo.png',
      title: 'Tốc độ truy cập nhanh hơn',
      content:
        'Wi-Fi 6 có tốc độ nhanh hơn (từ 600Mbps), gấp 4 lần tốc độ gói mạng thông thường; Tối ưu trải nghiệm chơi game trực tuyến, tải file dung lượng lớn hay xem video Ultra HD',
    },
    {
      icon: 'https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/ondinh.png',
      title: 'Ổn định & Tiết kiệm hơn',
      content:
        'Wi-Fi 6 sử dụng nhiều công nghệ mới tăng sự ổn định, giảm tắc nghẽn mạng khi sử dụng qua Wi-Fi. Điều chỉnh được thời gian hoạt động của thiết bị kết nối, giúp tiết kiệm và kéo dài tuổi thọ pin',
    },
    {
      icon: 'https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/baomat.png',
      title: 'Bảo mật dữ liệu tốt hơn',
      content:
        'Wi-Fi 6 bảo mật cao hơn, nhờ vào công nghệ WP3 để mã hoá dữ liệu và chống lại các cuộc tân công từ bên ngoài',
    },
  ];
  to6List: any = [
    {
      icon: 'https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/wifi-icon.png',
      title: 'WI-FI THẾ HỆ MỚI NHẤT',
      content: 'Công nghệ hàng đầu, thiết bị hiện đại số 1',
    },
    {
      icon: 'https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/connect-icon.png',
      title: 'KẾT NỐI VƯỢT TRỘI',
      content: 'Sóng Internet rộng hơn, nhanh hơn, mạnh hơn gấp 4 lần',
    },
    {
      icon: 'https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/unlimited-icon.png',
      title: 'PHỦ SÓNG KHÔNG GIỚI HẠN',
      content:
        'Phủ sóng Wi-Fi xuyên tường, giải trí đa nền tảng trên nhiều thiết bị cùng lúc',
    },
  ];

  listExclusive: any = [
    {
      content_1: 'Giảm',
      percentage: '70%',
      content_2: 'Phí nâng cấp lên wi-fi 6',
    },
    {
      content_1: 'Giảm tới ',
      percentage: '50%',
      content_2: 'khi mua thêm bộ phát <br/>(tối đa 2 thiết bị / hợp đồng)',
    },
  ];
  listPost = [
    {
      img: 'https://fpt.vn/storage/upload/images/articles2/tin-fpt/linh/700x410-blue.jpg',
      url: 'https://fpt.vn/vi/tin-fpt/kham-pha-dinh-cao-cong-nghe-voi-internet-the-he-moi-nhat-fpt-wi-fi-6-trai-nghiem-internet-khong-gioi-han--9691.html',
      title:
        'Khám phá đỉnh cao công nghệ với internet thế hệ mới nhất FPT Wi-Fi 6: Trải nghiệm internet không giới hạn',
      content:
        'FPT Wi-Fi 6 với những cải tiến vượt trội, đang định hình lại cách chúng ta truy cập và tận hưởng Internet: về tốc độ, vùng phủ trong nhà và sự mượt mà khi chơi game, livestream cũng như xem phim chất lượng cao.',
    },
    {
      img: 'https://foxnews.fpt.vn/wp-content/uploads/2024/04/1200x675-Green.jpg',
      url: 'https://foxnews.fpt.vn/fpt-wifi-6-va-hanh-trinh-mang-den-trai-nghiem-internet-tot-nhat-danh-cho-khach-hang/',
      title:
        'FPT Wi-Fi 6 và hành trình mang đến trải nghiệm internet tốt nhất dành cho khách hàng',
      content:
        'Tới tháng 4 này, hơn 200.000 khách hàng FPT Telecom đã sử dụng Wi-Fi 6 với những trải nghiệm khác biệt về tốc độ, vùng phủ trong nhà và sự mượt mà khi chơi game, livestream cũng như xem phim chất lượng cao.',
    },
    {
      img: 'https://fpt.vn/storage/upload/images/articles2/tin-fpt/linh/portrait-of-smiling-beautiful-business-asian-woman-working-in-office-use-computer-with-copy-space-business-owner-people-sme-freelance-online-marketing-e-commerce-telemarketing-work-from-home-concept-free-photo.jpg',
      url: 'https://fpt.vn/vi/tin-fpt/fpt-wi-fi-6-giai-phap-ket-noi-dong-bo-da-thiet-bi--9533.html',
      title: 'FPT Wi-Fi 6: Giải pháp kết nối đồng bộ đa thiết bị',
      content:
        'Wi-Fi 6 được tích hợp công nghệ chống nghẽn mạng khi có nhiều thiết bị truy cập cùng lúc, bảo đảm tốc độ và tín hiệu kết nối, đáp ứng nhu cầu nâng cao của người dùng. Không cần đầu tư thêm thiết bị mở rộng sóng (Access Point), Wi-Fi 6 hỗ trợ kết nối tới 30 thiết bị đồng bộ',
    },
    {
      img: 'https://hi-static.fpt.vn/sys/shop/prod/2024-04-15/661cffa34f437_thumb.png',
      url: 'https://shop.fpt.vn/tin-tuc/top-5-li-do-vi-sao-cac-gia-dinh-nen-lua-chon-lap-dat-fpt-wifi-6-546',
      title: 'Top 5 lí do vì sao các gia đình nên lựa chọn lắp đặt FPT Wi-Fi 6',
      content:
        'FPT Wi-Fi 6 đem đến trải nghiệm sóng Wi-Fi phủ rộng và len lỏi mọi ngóc ngách trong ngôi nhà bạn.Tham khảo bài viết dưới đây để biết tại sao đây là lựa chọn hàng đầu cho các hộ gia đình.',
    },
    {
      img: 'https://hi-static.fpt.vn/sys/shop/prod/2024-04-15/661d01c13d383_pasted%20image%200%20%281%29.png',
      url: 'https://shop.fpt.vn/tin-tuc/wifi-6-giai-phap-toi-uu-cho-game-thu-trai-nghiem-game-khong-gioi-han-va-muot-ma-547',
      title:
        'Wi-Fi 6: Giải pháp tối ưu cho game thủ - Trải nghiệm game không Giới Hạn và Mượt Mà',
      content:
        'Bạn là một game thủ đam mê tìm kiếm trải nghiệm chơi game mượt mà và không bị gián đoạn? Khám phá Wi-Fi 6 - công nghệ Wi-Fi mới nhất giúp cải thiện tốc độ và độ ổn định, đáp ứng hoàn hảo nhu cầu của bạn.',
    },
    {
      img: 'https://lh7-us.googleusercontent.com/zh034Wmp9z7OChNpBj1cdDFs-hwnOJyvpF8pPsw9KWb2nmlCFa7ZAKejlZMPpGtKR_aBgjBZ04nNOKsUACttmf8ueVq7_LLXAow0N3k7W5KcpcNVsyxkj52BxVWXkZ9g5uVs-cQIUdg40KLYb2_3Fco',
      url: 'https://shop.fpt.vn/tin-tuc/wifi-6-trai-nghiem-giai-tri-hoan-hao-cho-ca-gia-dinh-550',
      title: 'Wi-Fi 6: Trải Nghiệm Giải Trí Hoàn Hảo Cho Cả Gia Đình',
      content:
        'Wi-Fi 6 đã mang lại một bước tiến lớn trong việc cải thiện trải nghiệm giải trí, giúp cả gia đình cùng thưởng thức nhiều hoạt động trực tuyến mà không gặp phải tình trạng nghẽn mạng. Hãy cùng khám về lợi ích của Wi-Fi 6 trong bài viết dưới đây.',
    },
  ];
  prefixId: any;
  cusromerId: any;
  utmSource: any;
  contentLoaded: boolean = true;
  readonly getInfoSubject = new Subject();
  infoSubscription: any;
  slideConfig = {
    speed: 300,
    slidesToShow: 7,
    autoplaySpeed: 2000,
    slidesToScroll: 1,
    cssEase: 'linear',
    fade: false,
    autoplay: false,
    dots: false,
    draggable: true,
    arrows: false,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          dots: true,
        },
      },

      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: true,
        },
      },
    ],
  };

  scrollToSection(section: string) {
    const element = document.getElementById(section);
    if (element) {
      console.log('has');
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
    }
  }
  ngOnInit(): void {
    this.infoSubscription = this.getInfoSubject
      .pipe(
        switchMap(() =>
          this.swapWifiService.getInfo('6', {
            utm_source: this.utmSource,
          })
        )
      )
      .subscribe(
        (res: any) => {
          this.spinner.hide();
          if (res && res.status === 1) {
            if (res.detail.contract_info.swap_wifi6_status !== 'VALID') {
              this.router.navigate(['/swap-wifi-6'], {
                queryParams: { utm_source: this.utmSource },
              });
            } else {
              this.contentLoaded = true;
            }
          } else if (res && res.status === 999) {
            window.location.href = res.detail.redirect_url;
          } else {
            // Hiên popup
            this.confirm.confirm(
              'Thông báo',
              res.msg,
              'Đóng',
              undefined,
              'justify-content-end'
            );
          }
        },
        (errors: any) => {
          this.spinner.hide();
        }
      );
  }
  ngAfterViewInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const section = params['section'];
      if (section) {
        this.scrollToSection(section);
      }
    });
  }
  registerInfo() {
    this.router.navigate(['/swap-wifi-6'], {
      queryParams: { utm_source: this.utmSource },
    });
  }
  ngOnDestroy(): void {
    this.infoSubscription.unsubscribe();
  }
}
